import React from 'react';
import moment from 'moment';
import {dropdownFillBlack} from 'assets/images/images';
import {Accordion} from '../../../components';
import {isNestedObjectValuesTruthy} from '../../../helpers/isNestedObjectTruthy';
import {getStatusTextAndStyles} from 'helpers/getStatusTextAndStyles';
// import {BehaviouralDetails} from './BehaviouralDetails';

const ObjectMap = ({data = {}, checks = []}) =>
  Object.entries(data).map(
    ([key, value]) =>
      !checks?.includes(key) && (
        <div
          key={key}
          className="flex items-center justify-between py-3 border-t border-[#F6F7F9]"
        >
          <p className="text-small text-[#858DAA] capitalize">
            {key?.replaceAll('_', ' ')}
          </p>
          <p className="text-sm text-body">{value || '-'}</p>
        </div>
      ),
  );
function OnboardingDetails({onboardData}) {
  const userInfo = onboardData?.userEntity || onboardData?.entity || {};
  const identityDetails = onboardData?.identityAndVerification || [];

  const userDetails = [
    {
      label: 'Full Name',
      value: userInfo.user_name || '-',
    },
    {
      label: 'Email Address',
      value: userInfo.user_email || '-',
    },
    {
      label: 'Phone Number',
      value: userInfo.user_mobile || '-',
    },
    {label: 'User Type', value: userInfo.user_type || '-'},
    {
      label: 'Account Created',
      value: moment(userInfo.createdAt || '2025-09-11').format('MMM D, YYYY'),
    },
    {
      label: 'Account Status',
      value: userInfo.account_status || '-',
      isStatus: true,
    },
    {label: 'Nationality', value: userInfo.nationality || '-'},
  ];

  // const identityDetailss = [
  //   {
  //     title: 'KYC COVERAGE',
  //     items: [
  //       {
  //         label: 'Verified IDs',
  //         value: identityAndVerification.verified_ids || 'BVN',
  //       },
  //       {
  //         label: 'Total IDs Submitted',
  //         value: identityAndVerification.total_ids_submitted || '2',
  //       },
  //       {
  //         label: 'ID Types',
  //         value: identityAndVerification.id_types || '87%',
  //       },
  //     ],
  //   },
  //   {
  //     title: 'IDENTITY CONFIDENCE',
  //     items: [
  //       {
  //         label:
  //           'Percentage value showing how consistent the identity data is across sources.',
  //         value: identityAndVerification.identity_confidence || '87%',
  //       },
  //     ],
  //   },
  //   {
  //     title: 'ACCOUNT TENURE',
  //     items: [
  //       {
  //         label: 'Total number of days since account creation.',
  //         value: identityAndVerification.account_tenure || '7 days',
  //       },
  //     ],
  //   },
  //   {
  //     title: 'PROFILE STABILITY',
  //     items: [
  //       {
  //         label: 'Name Changes',
  //         value: identityAndVerification.name_changes || '5',
  //       },
  //       {
  //         label: 'Email Changes',
  //         value: identityAndVerification.email_changes || '6',
  //       },
  //       {
  //         label: 'Phone Changes',
  //         value: identityAndVerification.phone_changes || '-',
  //       },
  //     ],
  //   },
  //   {
  //     title: 'LINKED ACCOUNTS',
  //     items: [
  //       {
  //         label:
  //           'Number of profiles or accounts associated with the same identity or device.',
  //         value: identityAndVerification.linked_accounts || '-',
  //       },
  //     ],
  //   },
  // ];

  return (
    <div className="w-full">
      <div className="bg-white rounded-xl py-4">
        <div className="px-6 flex flex-col gap-1">
          <h4 className="text-deepBlue font-medium">Customer Information</h4>
          <p className="text-small text-[#858DAA]">
            Detailed information for the user
          </p>
        </div>
        <div className="px-3 mt-4 flex flex-col gap-4">
          {isNestedObjectValuesTruthy(userInfo) && (
            <Accordion
              title="User Information"
              customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
              customClasses="border border-[#F3F4F7] rounded-[12px]"
              customPadding="p-3 flex-col md:flex-row h-11 !items-start"
              customImg={dropdownFillBlack}
            >
              <div className="mt-1">
                {userDetails.map(item => {
                  if (item.isStatus) {
                    const statusInfo = getStatusTextAndStyles(item.value);
                    return (
                      <div
                        key={item.label}
                        className="flex items-center justify-between py-3 border-t border-[#F6F7F9] first:border-t-0"
                      >
                        <p className="text-small text-[#858DAA]">
                          {item.label}
                        </p>
                        <span
                          className={`text-small font-medium px-3 py-1 rounded-full ${
                            statusInfo.styles || ''
                          }`}
                        >
                          {statusInfo.text}
                        </span>
                      </div>
                    );
                  }

                  return (
                    <div
                      key={item.label}
                      className="flex items-center justify-between py-3 border-t border-[#F6F7F9] first:border-t-0"
                    >
                      <p className="text-small text-[#858DAA]">{item.label}</p>
                      <p className="text-tiny text-deepBlue">
                        {item.value || '-'}
                      </p>
                    </div>
                  );
                })}
              </div>
            </Accordion>
          )}
          {isNestedObjectValuesTruthy(onboardData?.employerEntity) && (
            <Accordion
              title="Employer Information"
              customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
              customClasses="border border-[#F3F4F7] rounded-[12px]"
              customPadding="p-3 flex-col md:flex-row h-11 !items-start"
              customImg={dropdownFillBlack}
            >
              <div className="mt-1">
                <ObjectMap checks={[]} data={onboardData?.employerEntity} />
              </div>
            </Accordion>
          )}

          {identityDetails.length > 0 && (
            <Accordion
              title="Identity Information"
              customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
              customClasses="border border-[#F3F4F7] rounded-[12px]"
              customPadding="p-3 flex-col md:flex-row h-11 !items-start"
              customImg={dropdownFillBlack}
            >
              <div className="mt-1">
                {identityDetails.map((section, index) => (
                  <div
                    key={section.id_number + index}
                    className="mb-2 last:mb-0"
                  >
                    <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-1 pb-4">
                      {section.id_type}
                    </h5>
                    <ObjectMap checks={['id_type']} data={section} />
                    {/*{section.items && section.items.length > 0 && (*/}
                    {/*  <div>*/}
                    {/*    {section.items.map(item => (*/}
                    {/*      <div*/}
                    {/*        key={item.label}*/}
                    {/*        className="flex items-start justify-between gap-4 py-3 border-t border-[#F6F7F9]"*/}
                    {/*      >*/}
                    {/*        <p className="text-small text-[#858DAA] w-[70%]">*/}
                    {/*          {item.label}*/}
                    {/*        </p>*/}
                    {/*        <p className="text-tiny text-deepBlue font-medium text-right">*/}
                    {/*          {item.value || '-'}*/}
                    {/*        </p>*/}
                    {/*      </div>*/}
                    {/*    ))}*/}
                    {/*  </div>*/}
                    {/*)}*/}
                  </div>
                ))}
              </div>
            </Accordion>
          )}
        </div>
      </div>
      {/*<BehaviouralDetails />*/}
    </div>
  );
}

export default OnboardingDetails;
